import AgencyConsultant from "./AgencyConsultant.js";
import AgencyDirector from "./AgencyDirector.js";
import BackOfficeUser from "./BackOfficeUser.js";
import CompanyUser from "./CompanyUser.js";
import CountryUser from "./CountryUser.js";
import ModelFactory from "./ModelFactory.js";
import UnknownUser from "./UnknownUser.js";

/**
 * `UserFactory` instantiates the correct user class depending on the
 * user type.
 *
 * Default is `unknownUser`.
 */
class UserFactory extends ModelFactory {
	allClasses() {
		return [
			AgencyConsultant,
			AgencyDirector,
			BackOfficeUser,
			CompanyUser,
			CountryUser,
			UnknownUser,
		];
	}

	_getTypeFromJson(json) {
		return json.typeOfUser;
	}

	_findClassFromType(type) {
		const klass = this.allClasses().find(
			(each) => each.matchesType && each.matchesType(type),
		);

		return klass || UnknownUser;
	}
}

const userFactory = new UserFactory();

export default userFactory;
